module.exports = "https://static.wanderu.com/ui-react/_next/static/media/kayak-logo.73d1e1d5.svg";